import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ManualViewer from "@/components/ManualViewer";
import { KannLoader } from "@/components/KannLoader";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function EmbedManual() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    fetch(`${BACKEND}/api/public/manuals/${id}`)
      .then((r) => { if (!r.ok) throw new Error(); return r.json(); })
      .then(setData)
      .catch(() => setError("Deze interactieve handleiding is niet beschikbaar."));
  }, [id]);

  if (error) return <div className="w-screen h-screen flex items-center justify-center bg-[#f6f6f4] text-[#6B6B6B] text-sm" data-testid="embed-error">{error}</div>;
  if (!data) return <div className="relative w-screen h-screen" data-testid="embed-loading"><KannLoader theme="light" /></div>;

  return (
    <div className="w-screen h-screen overflow-hidden" data-testid="embed-manual">
      <ManualViewer config={data.interactive} modelUrl={(aid) => `${BACKEND}/api/public/manual-models/${aid}`} productName={data.product_name} intro={data.intro} />
    </div>
  );
}
